import React, { Component } from 'react';

import { fetchOverduePurchases } from 'api';

const withSubOverdueInvoices = (DecoratedComponent) => {
  class WithSubOverdueInvoices extends Component {
    constructor(props) {
      super(props);

      this.state = {
        overdue: undefined,
      };
    }

    componentDidMount() {
      const { sub } = this.props;
      if (sub) {
        this.fetchPurchases(sub.user_profile);
      }
    }

    componentDidUpdate(oldProps) {
      const { sub } = this.props;
      if ((oldProps.sub && oldProps.sub.id) !== (sub && sub.id)) {
        this.fetchPurchases(sub.user_profile);
      }
    }

    async fetchPurchases(user_profile) {
      const { data } = await fetchOverduePurchases(user_profile);

      this.setState({
        overdue: data.results,
      });
    }

    render() {
      const { children, ...props } = this.props;
      const { overdue } = this.state;

      return React.createElement(
        DecoratedComponent,
        { ...props, overdue },
        children,
      );
    }
  }

  return WithSubOverdueInvoices;
};

export default withSubOverdueInvoices;
